export default "__VITE_ASSET__BHzBKw8Y__"